// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__fkrrI","name":"Header_name__2Ny5W","birthday":"Header_birthday__2vqOq","skeleton":"Header_skeleton__3tpaK"};